import { useEffect, useRef } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

export function SEOMetaTags() {
  const loaded = useRef(false);

  useEffect(() => {
    if (loaded.current) return;

    async function fetchMeta() {
      try {
        const res = await fetch(`${API}/api/seo/meta-tags`);
        if (!res.ok) return;
        const data = await res.json();

        const setMeta = (name, content, prop) => {
          if (!content) return;
          const attr = prop || "name";
          let el = document.querySelector(`meta[${attr}="${name}"]`);
          if (!el) {
            el = document.createElement("meta");
            el.setAttribute(attr, name);
            document.head.appendChild(el);
          }
          el.setAttribute("content", content);
        };

        if (data.description) setMeta("description", data.description);
        if (data.keywords) setMeta("keywords", data.keywords);
        if (data.og_title) setMeta("og:title", data.og_title, "property");
        if (data.og_description) setMeta("og:description", data.og_description, "property");
        if (data.title) document.title = data.title;

        loaded.current = true;
      } catch (err) {
        console.warn("SEO meta tags fetch failed:", err);
      }
    }
    fetchMeta();
  }, []);

  return null;
}
